import { Injectable, inject } from '@angular/core';
import { MatomoTracker } from 'ngx-matomo-client';
import { LocationMapAnalyticsAction } from './location-map-analytics-actions';

const LOCATION_MAP_CATEGORY = 'LocationMap';

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  // optional: si Matomo n'est pas configuré (ou pas mocké dans un contexte de test),
  // l'analytics ne doit jamais faire planter l'app — on devient simplement un no-op.
  private readonly tracker = inject(MatomoTracker, { optional: true });

  setUserId(userId: string): void {
    this.tracker?.setUserId(userId);
  }

  resetUserId(): void {
    this.tracker?.resetUserId();
  }

  setCustomDimension(customDimensionId: number, customDimensionValue: string): void {
    this.tracker?.setCustomDimension(customDimensionId, customDimensionValue);
  }

  private trackEvent(category: string, action: string, name?: string, value?: number): void {
    this.tracker?.trackEvent(category, action, name, value);
  }

  trackMapAction(action: LocationMapAnalyticsAction, name?: string, value?: number): void {
    this.trackEvent(LOCATION_MAP_CATEGORY, action, name, value);
  }
}
